<template >
  <div
    v-bind:class="[
      showContainer == true ? 'container-fluid videoshowcontainer' : '',
    ]"
    v-if="lesson"
  >
    <div class="row ml-4">
      <div class="col-md-8 col-sm-12">
        <div class="card mycard mb-4 p-0" v-if="topic && item">
          <!-- <div class="card-header py-3">
                </div> -->
          <div class="card-body">
            <div v-if="item">
              <h3 class="mb-1 ml-1 font-weight-bold content-title">
                {{ topic.name }} {{ studentData.id }} {{ item.type }}
              </h3> 
              <br />
              <div
                v-if="item.description"
                class="alert alert-danger"
                role="alert"
              >
                <p class="mb-1">{{ item.description }}</p>
              </div>

              <small
                v-if="studentScore && studentScore.lastViewedAt"
                style="margin-bottom: 20px"
                class="text-primary"
              >
                Нэвтэрсэн огноо:
                {{ getFullDate(studentScore.lastViewedAt) }}</small
              >
              <!-- <p class="text-success">
                  {{remainingDays}}, H: {{remainingHours}}: {{remainingMinutes}}: {{remainingSeconds}}
                  calculated: {{timeCalculated}}
              </p> -->
              <div
                class="d-flex w-100 justify-content-between"
                style="margin-top: 10px"
              >
                <div>
                  <p class="mb-1" v-if="item.duration != null">
                    Үргэлжлэх хугацаа :{{ item.duration }} минут
                  </p>
                  <p class="mb-1" v-if="item.startDay != null">
                    Эхлэх: {{ item.startDay | formatDate }}
                  </p>
                  <p class="mb-1 text-danger" v-if="item.endDay != null">
                    Дуусах:
                    <span class="font-weight-bold">{{
                      getFullDate(item.endDay)
                    }}</span>
                  </p>
                  <p
                    v-if="
                      item.totalScore &&
                      item.totalScore != '' &&
                      item.totalScore != 0
                    "
                  >
                    Дүгнэх оноо:
                    <span class="font-weight-bold text-danger">{{
                      item.totalScore
                    }}</span>
                  </p>
                </div>
                <div>
                  <h3
                    v-if="
                      studentScore &&
                      studentScore.answer != null &&
                      studentScore.earnedScore != null
                    "
                  >
                    Авсан оноо:
                    <span class="text-danger font-weight-bold">{{
                      studentScore.earnedScore
                    }}</span>
                  </h3>
                  <p
                    v-else-if="
                      studentScore &&
                      studentScore.answer != null &&
                      studentScore.earnedScore == null
                    "
                    class="badge badge-danger pa-2"
                  >
                    Дүгнэгдээгүй!
                  </p>
                </div>
              </div>

              <hr />
              <div v-if="item.videoUrl">
                <div :ref="'youtube_container_' + item.id" class="video">
                  <youtube
                    :resize="true"
                    :fitParent="true"
                    v-if="item.videoUrl"
                    :video-id="getYoutubeIframe(item.videoUrl)"
                    :ref="'youtube' + item.id"
                    :player-vars="playerVars"
                    @playing="playing(topic, item)"
                  ></youtube>
                  <br />
                  <!-- video control buttons -->
                  <div class="row mt-2" style="padding: 1.25rem">
                    <div class="col">
                      <button
                        class="btn btn-primary"
                        v-if="item.videoUrl != null && item.videoUrl != ''"
                        @click="playVideo(item.id)"
                      >
                        <i class="fas fa-play"></i> Видео тоглуулах
                      </button>
                    </div>
                    <div>
                      <button
                        class="btn btn-danger ml-3"
                        v-if="item.videoUrl != null && item.videoUrl != ''"
                        @click="pauseVideo(item.id)"
                      >
                        <i class="fas fa-pause"></i> Видео зогсоох
                      </button>
                    </div>
                    <div>
                      <button
                        class="btn bg-gray-200 ml-3"
                        v-if="item.videoUrl != null && item.videoUrl != ''"
                        @click="fullScreen(item.id)"
                      >
                        <i class="fas fa-expand"></i>
                      </button>
                    </div>
                  </div>
                  <!-- <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="exitfullScreen(item.id)"><i class="fas fa-expand"></i>Exit FullScreen</button> -->
                  <!-- <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="exitfullScreen(item.id)"><i class="fas fa-compose"></i>Exit FullScreen</button> -->
                </div>
              </div>

              <div class="my-3" v-if="item.iframeurl && item.iframeurl != ''">
                <div id="iframecontainer" v-html="item.iframeurl"></div>
              </div>
              <div v-if="item.fileUrls != null && item.fileUrls.length > 0">
                <hr />
                <h5 class="text-center">Файлууд</h5>
                <table class="table table-bordered table-sm">
                  <tr v-for="(file, index) in item.fileUrls">
                    <td>{{ file.name }}</td>
                    <td>{{ file.description }}</td>
                    <td>
                      <a
                        class="btn btn-outline-primary btn-sm mr-2"
                        v-bind:href="file.link"
                        target="_blank"
                      >
                        <i class="fas fa-download"></i>
                        Татах
                      </a>
                    </td>
                  </tr>
                </table>
              </div>

              <div>
                <ul v-if="itemDetails != null && itemDetails.length > 0">
                  <li
                    v-for="(subdetail, index) in itemDetails"
                    v-bind:key="index"
                  >
                    {{ subdetail.data().name }}({{
                      subdetail.data().numberOfUnderstand
                    }})
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-footer" v-if="item.type == 'assignment'">
            <div class="d-flex justify-content-end">
              <button
                v-if="
                  studentScore &&
                  studentScore.answer == null 
                "
                type="button"
                class="btn btn-success"
                data-toggle="modal"
                data-target="#uploadAssignment"
                data-whatever="@mdo"
              >
                Далгавар өгөx
              </button>
              <button
                v-else-if="studentScore && studentScore.answer != null"
                type="button"
                class="btn btn-primary"
              >
                Далгавар өгсөн
              </button>
              <!-- <button
                v-else-if="
                  studentScore &&
                  studentScore.answer == null &&
                  item.endDay == null
                "
                type="button"
                class="btn btn-danger"
                data-toggle="modal"
                data-target="#uploadAssignment"
                data-whatever="@mdo"
              >
                Далгавар өгөx (xугацаагүй)
              </button>
              <button
                v-else-if="timeCalculated == -1"
                type="button"
                class="btn btn-danger"
              >
                Xугацаа дууссан
              </button> -->
            </div>
            <!-- <div
              class="d-flex justify-content-end"
              v-if="studentScore && studentScore.answer == null"
            >
              <vue-countdown-timer
                @start_callback="_startCallBack('event started')"
                @end_callback="_endCallBack('')"
                :start-time="getFullDate(studentScore.lastViewedAt)"
                :end-time="getFullDate(item.endDay)"
                :interval="1000"
                :start-label="'Үлдсэн xугацаа:'"
                :end-label="'Үлдсэн xугацаа:'"
                label-position="begin"
                :end-text="'Xугацаа дууссан!'"
                :day-txt="'өдөр'"
                :hour-txt="'цаг'"
                :minutes-txt="'минут'"
                :seconds-txt="'сек'"
              >
              </vue-countdown-timer>
            </div> -->
            <!-- <p class="content-subtitle">
              {{ item.createdAt | formatDate }}
            </p> -->
          </div>
        </div>
        <div class="card mycard mb-4 p-0">
          <div class="card-header">
              <h4>Chats <span v-if="chats">({{chats.length}})</span> </h4>
          </div>
          <div class="card-body">
            <div
              v-if="chats && chats.length > 0"
              style="height: 40vh; overflow-y: scroll; overflow-x: hidden"
            >
              <div v-for="(message, mindex) in chats" :key="mindex" style="">
                <span v-if="userProfile.customer.path == message.createdBy.path" 
                  class="font-weight-bold">{{ message.name }}: </span>
               <span v-else
                  class="font-weight-bold text-primary">{{ message.name }}: </span>
                {{ message.text }}
                <p class="text-right">
                  <small>{{ message.createdAt | formatDate }}</small>
                </p>
              </div>
            </div>
            <div v-else>
              <h5 class="text-center">No messages!</h5>
            </div>
            <textarea
              v-model="chatText"
              class="form-control mt-1"
              rows="3"
            ></textarea>
            <v-row class="mt-2">
              <v-spacer> </v-spacer>
              <v-btn
                v-if="chatText"
                @click="_sendChat()"
                color="success"
                class="align-right"
                >илгээx</v-btn
              >
            </v-row>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-4">
        <div v-if="school && school.university == true">
          <public-topics
            v-if="topics && topics.length > 0"
            :_editTopic="_editTopic"
            :topics="topics"
            :lesson="lesson"
            :schoolId="schoolId"
            :types="types"
            :lessonId="lesson.id"
          ></public-topics>
          <div v-else class="alert alert-warning text-center mb-4">
            <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
          </div>
        </div>
        <div class="doscroll" v-else>
          <div
            class="card pl-3 videoshowcontainer"
            v-for="(semester, sindex) in semesters"
            :key="sindex"
          >
            <!-- <h4 class="p-2 text-center">Xичээлүүд</h4> -->
            <div
              class="mt-3"
              v-for="(topic, index) in semester.topics"
              v-bind:key="topic.id"
              v-if="semester.topics != null && semester.topics.length > 0"
            >
              <h5 class="my-1 card-title text-primary mb-0 font-weight-bold">
                Сэдэв {{ index + 1 }}. {{ topic.name }}
              </h5>
              <hr class="mt-0" />
              <div
                class="row mb-2"
                v-for="item in topic.details"
                v-bind:key="item.id"
                @click="setCurrentVideo(topic, item)"
              >
                <div class="col-md-4">
                  <div v-if="item.videoUrl">
                    <a style="cursor: pointer">
                      <img
                        style="width: 100%; height: 100px"
                        :src="getYoutubeImg(item.videoUrl)"
                        alt=""
                      />
                    </a>
                  </div>
                  <div v-else class="my-2">
                    <a style="cursor: pointer">
                      <img
                        style="width: 100%; height: 100px"
                        :src="
                          'https://via.placeholder.com/300x200/09f/fff.png?text=' +
                          item.name
                        "
                        alt=""
                      />
                    </a>
                  </div>
                </div>
                <div class="col-md-8">
                  <div>
                    <span
                      class="font-weight-bold"
                      style="cursor: pointer; color: #030303"
                      >{{ item.name }}</span
                    >
                  </div>
                  <span
                    v-if="item.type == 'lecture'"
                    class="badge badge-warning"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >
                  <span
                    v-else-if="item.type == 'video'"
                    class="badge badge-warning"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >
                  <span
                    v-else-if="item.type == 'seminar'"
                    class="badge badge-warning"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >

                  <span
                    v-else-if="item.type == 'coursework'"
                    class="badge badge-info"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >
                  <span
                    v-else-if="item.type == 'assignment'"
                    class="badge badge-info"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >

                  <span
                    v-else-if="item.type == 'test'"
                    class="badge badge-danger"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >
                  <span
                    v-else-if="item.type == 'exam'"
                    class="badge badge-danger"
                    style="color: black"
                    >{{ getType(item.type) }}</span
                  >
                </div>
              </div>
            </div>

            <div v-else class="alert alert-warning text-center mb-4">
              <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="uploadAssignment"
      tabindex="-1"
      role="dialog"
      aria-labelledby="uploadAssignment"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Даалгавар өгөx</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="message-text" class="col-form-label"
                  ><span class="text-danger">IFrame</span> link (Даалгаварын
                  файлын линк) :</label
                >
                <textarea
                  v-model="answerDoc.iframeLink"
                  class="form-control"
                  id="message-text"
                ></textarea>
              </div>
              <div class="form-group">
                <label for="message-text" class="col-form-label"
                  >Багшдаа тайлбар бичиx:</label
                >
                <textarea
                  v-model="answerDoc.answerText"
                  class="form-control"
                  id="message-text"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Xааx
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="_sendAssignment"
            >
              Илгээx
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import LessonHeader from "../school/lesson/ILessonHeader";
import PublicTopics from "./PublicTopics";
import Vue from "vue";
import VueYoutube from "vue-youtube";
import axios from "axios";

Vue.use(VueYoutube);

export default {
  name: "StudentDetail",
  components: {
    LessonHeader,
    PublicTopics,
  },
  watch: {
    // item: function () {
    //   axios
    //     .get("https://worldtimeapi.org/api/timezone/Asia/Ulaanbaatar")
    //     .then((response) => {
    //       var currentTime = new Date(Date.parse(response.data.datetime));
    //       var endTime = this.item.endDay.toDate();
    //       if (
    //         this.item &&
    //         endTime &&
    //         endTime.getFullYear() == currentTime.getFullYear() &&
    //         currentTime.getMonth() == endTime.getMonth()
    //       ) {
    //         this.item.dayDiff = endTime.getDate() - currentTime.getDate();
    //       } else this.item.dayDiff = -1;
    //       //this.item.currentTime = currentTime
    //     });
    // },
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  data() {
    return {
      chatText: null,
      remainingDays: null,
      remainingHours: null,
      remainingMinutes: null,
      remainingSeconds: null,

      answerDoc: {
        iframeLink: null,
        answerText: null,
      },
      lesson: null,
      topic: null,
      item: null,
      types: [],
      selectedType: null,
      content: {},
      itemDetails: [],
      selectedTopic: null,

      display: 0,
      sub: {
        name: null,
      },
      playerVars: {
        autoplay: 0,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        fs: 0,
        allowfullscreen: 1,
        // controls:0,
        // allowfullscreen:true,
        // autohide:1
      },
      semesters: [],
      topics: [],
      school: null,
      done: false,
      studentData: null,
      studentScore: null,

      timeCalculated: null,
      chats: null,
    };
  },

  methods: {
    _sendChat(student) {
      if (this.chatText) {
        console.log(this.studentData.id)
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(this.topicId)
          .collection("details")
          .doc(this.contentId)
          .collection("sstudents")
          .doc(this.studentData.id)
          .collection("chats")
          .doc()
          .set({
            text: this.chatText,
            createdAt: new Date(),
            createdBy: this.userProfile.customer,
            name: this.userProfile.name,
          })
          .then(() => {
            this.chatText = null;
          });
      }
    },
    _readChat(path) {
      console.log(path)
      fb.db
        .doc(path)
        .collection("chats")
        .orderBy("createdAt", "asc")
        .onSnapshot((querySnapshot) => {
          this.chats = [];
          querySnapshot.forEach((doc) => {
            let message = doc.data();
            message.id = doc.id;
            message.ref = doc.ref;
            this.chats.push(message);
          });
        });
    },
    _startCallBack: function (x) {
      console.log(x);
    },

    _endCallBack: function (x) {
      console.log(x);
      this.timeCalculated = -1;
    },
    async _getDiffDay() {
      if (this.item.endDay && this.item.endDay != null) {
        if (
          this.studentScore.lastViewedAt &&
          this.studentScore.lastViewedAt != null
        ) {
          const today = this.studentScore.lastViewedAt.toDate();
          const endDate = this.item.endDay.toDate();
          const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
          const hours = parseInt(
            (Math.abs(endDate - today) / (1000 * 60 * 60)) % 24
          );
          const minutes = parseInt(
            (Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60)) % 60
          );
          const seconds = parseInt(
            (Math.abs(endDate.getTime() - today.getTime()) / 1000) % 60
          );

          this.remainingDays = days;
          this.remainingHours = hours;
          this.remainingMinutes = minutes;
          this.remainingSeconds = seconds;

          console.log(this.remainingDays != null && this.remainingDays > 0);
          console.log(this.remainingHours != null && this.remainingHours > 0);
          console.log(
            this.remainingMinutes != null && this.remainingMinutes > 0
          );
          console.log(
            this.remainingSeconds != null && this.remainingSeconds > 0
          );
          console.log(
            (this.remainingDays != null && this.remainingDays > 0) ||
              (this.remainingHours != null && this.remainingHours > 0) ||
              (this.remainingMinutes != null && this.remainingMinutes > 0) ||
              (this.remainingSeconds != null && this.remainingSeconds > 0)
          );

          if (
            (this.remainingDays != null && this.remainingDays > 0) ||
            (this.remainingHours != null && this.remainingHours > 0) ||
            (this.remainingMinutes != null && this.remainingMinutes > 0) ||
            (this.remainingSeconds != null && this.remainingSeconds > 0)
          ) {
            console.log("93skssssssssssssssssssssssssssssssssssssssssssssss");
            this.timeCalculated = 1;
          } else {
            this.timeCalculated = -1;
          }
        }
      } else {
        this.timeCalculated = 0;
      }
    },
    async _sendAssignment() {
      // var studentData = null
      // console.log(this.userProfile.customer.customerId)
      //  if(this.userProfile && this.userProfile.customer){
      //   await this.userProfile.customer.get().then(async doc=>{
      //     studentData=doc.data();
      //     studentData.id=doc.id;
      //     studentData.ref=doc.ref;
      //  })}

      if (
        this.answerDoc.iframeLink != null &&
        this.answerDoc.iframeLink != ""
      ) {
        var yes = confirm(this.studentData.id + ": Даалгавар илгээx үү?");
        if (yes) {
          //TODO save
          // /schools/xUSN7smB3EcLwDYhs1Y9/lessons/58IZSQWUkNbOknrZG4ks/topics/6y85k4FK7HBoKb7GNDUT/details/ypozGrQMkFQluD9tsyni/sstudents
          console.log(
            this.schoolId,
            this.lessonId,
            this.topicId,
            this.contentId
          );
          var path =
            "/schools/" +
            this.schoolId +
            "/lessons/" +
            this.lessonId +
            "/topics/" +
            this.topicId +
            "/details/" +
            this.contentId +
            "/sstudents/";

          if (this.studentData != null) {
            path = path + this.studentData.id;
            console.log(path);
            fb.db
              .doc(path)
              .set(
                { answer: this.answerDoc, sentAt: new Date() },
                { merge: true }
              )
              .then(() => {
                yes = confirm("Таны даалгавар амжилттай илгээгдлээ!");
                this.done = true;
              })
              .catch((error) => {
                confirm("Илгээгдэж чадсангүй. Алдаа гарлаа.");
              });
          }
          this.answerDoc = {
            iframeLink: null,
            answerText: null,
          };
          $("#uploadAssignment").modal("hide");
        }
      }
    },
    setCurrentVideo(topic, item) {
      this.$nextTick(() => {
        this.playerVars = {
          autoplay: 0,
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
          fs: 0,
          allowfullscreen: 1,
          // controls:0,
          // allowfullscreen:true,
          // autohide:1
        };
        this.topic = topic;
        this.item = item;
      });
    },
    async playVideo(videoId) {
      if (this.$refs["youtube" + videoId].player) {
        await this.$refs["youtube" + videoId].player.playVideo();
      }
    },
    async pauseVideo(videoId) {
      if (this.$refs["youtube" + videoId].player != undefined)
        await this.$refs["youtube" + videoId].player.pauseVideo();
    },
    fullScreen(videoId) {
      Vue.nextTick(() => {
        if (this.$refs["youtube" + videoId].player != undefined) {
          var player = this.$refs["youtube" + videoId].player;
          player.playVideo(); //won't work on mobile

          var iframe = this.$refs["youtube_container_" + videoId];
          var requestFullScreen =
            iframe.requestFullScreen ||
            iframe.mozRequestFullScreen ||
            iframe.webkitRequestFullScreen ||
            iframe.msRequestFullscreen;
          if (requestFullScreen) {
            requestFullScreen.bind(iframe)();
          }
        }
      });
    },
    exitfullScreen(videoId) {
      if (this.$refs["youtube" + videoId].player != undefined) {
        var player = this.$refs["youtube" + videoId].player;
        player.playVideo(); //won't work on mobile

        var document = this.$refs["youtube_container_" + videoId];
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    playing(topic, content) {
      console.log("o/ we are watching!!!" + content.id);
      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .collection("studentList")
        .doc(this.$store.getters.userProfile.customer.id)
        .get()
        .then((std) => {
          if (std.exists) {
            if (
              this.$store.getters.userProfile != null &&
              this.$store.getters.userProfile.role == "student"
            ) {
              if (topic != null && content != null) {
                var contentRef = fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lessonId)
                  .collection("topics")
                  .doc(topic.id)
                  .collection("details")
                  .doc(content.id);
                contentRef
                  .collection("watchedStudents")
                  .doc(std.id)
                  .get()
                  .then((stdWatch) => {
                    if (stdWatch.exists) {
                      stdWatch.ref.update({
                        watchedDates: fb.firestore.FieldValue.arrayUnion(
                          new Date()
                        ),
                      });
                    } else {
                      stdWatch.ref.set({
                        createdAt: new Date(),
                        watchedDates: [new Date()],
                      });
                      this.countStudentVideo(topic, content, "viewCount");
                    }
                  });
              }
            }
          }
        });
    },
    countStudentVideo(topic, content, prop) {
      console.log("count");
      if (
        this.$store.getters.userProfile != null &&
        this.$store.getters.userProfile.role == "student"
      ) {
        if (topic != null && content != null) {
          var contentRef = fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc(topic.id)
            .collection("details")
            .doc(content.id);
          var updateObj = {};
          updateObj[prop] = fb.firestore.FieldValue.increment(1);
          contentRef.update(updateObj);
        }
      }
    },
    async _getQA() {
      if (this.userProfile && this.userProfile.customer) {
        console.log();
        await this.userProfile.customer.get().then((doc) => {
          this.studentData = doc.data();
          this.studentData.id = doc.id;
          this.studentData.ref = doc.ref;
        });
      }

      console.log(this.studentData.id);
      if (this.studentData != null) {
        var path =
          "/schools/" +
          this.schoolId +
          "/lessons/" +
          this.lessonId +
          "/topics/" +
          this.topicId +
          "/details/" +
          this.contentId +
          "/sstudents/";

        path = path + this.studentData.id;

        fb.db.doc(path).set(
          {
            lastViewedAt: fb.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        );

        fb.db.doc(path).onSnapshot((doc) => {
          console.log("STEP-1");

          if (doc.exists) {
            this.studentScore = doc.data();
            console.log(this.studentScore != null);
            console.log("STEP-2");
            this.studentScore.id = doc.id;
            this.studentScore.ref = doc.ref;
            console.log("STEP-2A");
          } else {
            console.log("STEP-3");
            fb.db.doc(path).set(
              {
                loggedAt: fb.firestore.FieldValue.serverTimestamp(),
                answer: null,
                earnedScore: null,
                lastViewedAt: fb.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            );
          }
        });
        this._readChat(path);
      }

      fb.db
        .collection("ContentTypes")
        .get()
        .then((querySnapshot) => {
          this.types = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
          });
        });

      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolDoc) => {
          if (schoolDoc.exists) {
            let school = schoolDoc.data();
            school.id = schoolDoc.id;
            this.school = school;
            if (school && school.university && school.university == true) {
              fb.db
                .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
                .collection("topics")
                .orderBy("createdAt", "desc")
                .onSnapshot((querySnapshot) => {
                  this.topics = [];
                  querySnapshot.forEach((doc) => {
                    let object = doc.data();
                    object.id = doc.id;
                    object.details = [];
                    if (!object.published) object.published = null;
                    doc.ref
                      .collection("details")
                      .orderBy("createdAt")
                      .onSnapshot((contentSnapshot) => {
                        object.details = [];
                        contentSnapshot.forEach((contentDoc) => {
                          let content = contentDoc.data();
                          content.id = contentDoc.id;
                          content.uploading = false;
                          content.uploadPercent = 0;
                          if (content && content.iframeurl) {
                            if (
                              content.iframeurl.includes(
                                "docs.google.com/document"
                              )
                            ) {
                              content.iframeurl = content.iframeurl.replace(
                                "<iframe ",
                                "<iframe style='heigth:1024px'"
                              );
                            }
                          }
                          object.details.push(content);
                        });
                      });
                    this.topics.push(object);
                  });
                });
            } else {
              fb.db
                .collection("schools/" + this.schoolId + "/semester")
                .orderBy("createdAt", "desc")
                .get()
                .then((semesterSnapshot) => {
                  semesterSnapshot.docs.forEach((semesterDoc) => {
                    let semester = semesterDoc.data();
                    semester.id = semesterDoc.id;
                    semester.path = semesterDoc.ref.path;
                    semester.topics = [];
                    fb.db
                      .doc(
                        "schools/" + this.schoolId + "/lessons/" + this.lessonId
                      )
                      .collection("topics")
                      .where("semester", "==", semesterDoc.ref)
                      .orderBy("createdAt", "desc")
                      .onSnapshot((querySnapshot) => {
                        semester.topics = [];
                        querySnapshot.forEach((doc) => {
                          let object = doc.data();
                          object.id = doc.id;
                          object.details = [];
                          doc.ref
                            .collection("details")
                            .orderBy("createdAt")
                            .onSnapshot((contentSnapshot) => {
                              object.details = [];
                              contentSnapshot.forEach((contentDoc) => {
                                let content = contentDoc.data();
                                content.id = contentDoc.id;
                                content.uploading = false;
                                content.uploadPercent = 0;
                                if (content && content.iframeurl) {
                                  if (
                                    content.iframeurl.includes(
                                      "docs.google.com/document"
                                    )
                                  ) {
                                    content.iframeurl = content.iframeurl.replace(
                                      "<iframe ",
                                      "<iframe style='height:1024px!important;'"
                                    );
                                  }
                                }
                                object.details.push(content);
                              });
                            });
                          semester.topics.push(object);
                        });
                      });
                    this.semesters.push(semester);
                  });
                });
            }
          }
        });

      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get()
        .then((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          this.lesson = lesson;
          doc.ref
            .collection("topics")
            .doc(this.topicId)
            .get()
            .then((tdoc) => {
              if (tdoc.exists) {
                let topic = tdoc.data();
                topic.id = tdoc.id;
                this.topic = topic;

                tdoc.ref
                  .collection("details")
                  .doc(this.contentId)
                  .onSnapshot(async (cdoc) => {
                    if (cdoc.exists) {
                      let item = cdoc.data();
                      item.id = cdoc.id;
                      item.uploading = false;
                      item.uploadPercent = 0;
                      if (item && item.iframeurl) {
                        if (
                          item.iframeurl.includes("docs.google.com/document")
                        ) {
                          console.log(")))))))))))))))))0");
                          item.iframeurl = item.iframeurl.replace(
                            "<iframe ",
                            "<iframe style='height:1024px!important;'"
                          );
                        }
                      }
                      this.item = item;
                      if (this.item.endDay) await this._getDiffDay();

                      cdoc.ref
                        .collection("subdetails")
                        .orderBy("createdAt", "desc")
                        .onSnapshot((docs) => {
                          if (docs != null && !docs.empty) {
                            this.itemDetails = docs.docs;
                          }
                        });
                    }
                  });
              }
            });
        });

      console.log(path);
    },

    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { lessonId: this.lessonId, type: type.id, topicId: topic.id },
      });
    },

    setPropContent(value, topic, item, propertyName) {
      if (
        this.lesson != null &&
        topic != null &&
        item != null &&
        propertyName != null
      )
        this.setProperty(
          propertyName,
          fb.db.doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lesson.id +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          ),
          value
        );
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    validFile(file) {
      if (
        file.fileName.endsWith("mp4") ||
        file.fileName.endsWith("MP4") ||
        file.fileName.endsWith("MPEG") ||
        file.fileName.endsWith("mov") ||
        file.fileName.endsWith("MOV") ||
        file.fileName.endsWith("webm") ||
        file.fileName.endsWith("WEBM")
      ) {
        return false;
      }
      return true;
    },
    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeImg(url) {
      if (url) {
        var id = this.getYoutubeId(url);
        if (id) {
          return "https://img.youtube.com/vi/" + id + "/1.jpg";
        }
      }
      return null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return id;
      }
      return null;
    },
    getType(type) {
      //video, assignment, test, exam

      if (type == "video") return "Хичээл";
      else if (type == "assignment") return "Даалгавар";
      else if (type == "test") return "Сорил";
      else if (type == "exam") return "Шалгалт";
      else if (type == "lecture") return "Хичээл";
      else if (type == "seminar") return "Семинар";
      // else if(type=="homework")
      //   return "Гэрийн даалгавар";
      else if (type == "coursework") return "Бие даалт";
    },
    getFullDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    topicId: {
      required: true,
    },
    contentId: {
      required: true,
    },
    showContainer: {
      required: false,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") this._getQA();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM-DD-YYYY HH:mm:ss");
    },
  },
};
</script>
<style>
.video iframe {
  pointer-events: none;
}
#iframecontainer iframe {
  width: 100% !important;
}
</style>
